import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {renderArchivingButton} from '@utils/archiving';
import {convertToInt} from '@utils/helpers';
import {ToggleArchiveStateProductionCompany} from '@graphql/productionCompany/mutation';

export class ProductionCompanyForm extends DefaultForm {
    componentDidMount() {
        this.setDeleteSuccessCallback(() => {
            this.props.history.push(getLink('productionCompanies.index'));
        });
        this.setCreateSuccessCallback((response) => {
            this.props.history.push(getLink('productionCompanies.edit', {
                id: response.data.createProductionCompany.id,
            }));
        });
    }

    prepareDataForSubmit = (data) => ({
        ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
        ...data,
        country: data?.country ? convertToInt(data.country) : null,
        client: data?.client ? convertToInt(data.client) : null,
    });

    renderErrors(errorData) {
        super.renderErrors(
            errorData,
            'Production company',
            getLink('productionCompanies.index'),
            {size: 'tiny'}
        );
    }

    renderArchiveButton = () => (
        renderArchivingButton(
            {
                ...this.props,
                callbackLink: getLink('productionCompanies.index'),
                messageBoxName: 'productionCompanyMessage',
            },
            ToggleArchiveStateProductionCompany,
            {
                id: convertToInt(this.props.match.params.id),
                name: _get(this.props, 'GraphQLEntityData.productionCompany.name', null),
            }
        )
    );

    renderCancelButton = () => null;
}

export default withRouter(ProductionCompanyForm);
